/**
 * Race to 17 helpers — same logic as the reference admin (Vue raceto17 page).
 */
const BASE = import.meta.env.BASE_URL;

/** Reference Card component: `${IMG_PATH}admin/img/cards/${card}.png` (card "1" = back). */
export const race17CardImg = (token) => `${BASE}img/cards/${token}.png`;

export function parseRace17Cards(cardString) {
  const cards = cardString ? String(cardString).split(",") : [];
  let totalPoints = 0;
  for (const n of cards) {
    // Reference: o = "0"; if (n != 1) o = rank; 10/J/Q/K = 0, A = 1
    let o = "0";
    if (n.trim() !== "1") o = n.length === 4 ? n.slice(0, 2) : n.slice(0, 1);
    if (o === "10" || o === "J" || o === "Q" || o === "K") o = "0";
    if (o === "A") o = "1";
    const v = parseInt(o, 10);
    if (!Number.isNaN(v)) totalPoints += v;
  }
  return { cards, totalPoints };
}

/** Reference `toCurrency`: en-IN grouping, up to 2 decimals. */
export function toCurrency(a) {
  if (a == null) return "";
  return parseFloat(a).toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}
